// 字典集合

/**
 * @description 默认获取label值
 * @param {Array} options 字典数组
 * @param {Number} value value值，（如果是多个用','隔开，如:value:'1,2'）
 * @param {String} label 取某个key的值，默认label
 * @returns {String} 返回value对应的文本汉字值
 */
export const getLabelByValue = (options, value, label = 'label') => {
    if ([null, undefined, ''].includes(value)) {
        return '-';
    }
    let _list = options.filter((item) => String(value).split(',').includes(String(item.value)));
    let _label = _list.map((item) => item[label]).join('、');
    return _label;
};

/**
 * @description 截取部分字典
 * @param {Array} options 字典数组
 * @param {Array} values [1, 2] 要截取的value值数组
 * @param {Boolean} isSortByValues 是否根据传入数组的顺序进行返回 true传入什么顺序返回什么 false根据字典数组顺序返回
 */
export const sliceDictByValues = (options, values, isSortByValues = false) => {
    if (isSortByValues) {
        const arr = [];
        values.map((item) => {
            for (let i = 0; i < options.length; i++) {
                if (options[i].value === item) {
                    arr.push(options[i]);
                }
            }
        });
        return arr;
    }
    return options.filter((item) => values.includes(item.value));
};

// 平均库存
export const averageStocksDict = [
    { value: 30, label: '近30天平均库存' },
    { value: 60, label: '近60天平均库存' },
    { value: 90, label: '近90天平均库存' },
    { value: 120, label: '近120天平均库存' },
    { value: 180, label: '近180天平均库存' },
];

// 平均出库
export const averageOutboundsDict = [
    { value: 30, label: '近30天平均出库' },
    { value: 60, label: '近60天平均出库' },
    { value: 90, label: '近90天平均出库' },
    { value: 120, label: '近120天平均出库' },
    { value: 180, label: '近180天平均出库' },
];

// 【门店店检审核状态】
export const storeInspectAuditStatusDict = [
    { value: 1, label: '门店未提交' },
    { value: 2, label: '门店已提交' },
    { value: 3, label: '业务主管已审核' },
    { value: 4, label: '审核完成' },
];

// 【门店店检审核状态2025年后】
export const storeInspectAuditStatus2025Dict = [
    { value: 0, label: '门店未提交', color: '#f90' },
    { value: 1, label: '待业务主管审核', color: '#f90' },
    { value: 40, label: '待渠道员审核', color: '#2d8cf0' },
    { value: 4, label: '审核合格', color: '#19be6b' },
    { value: 5, label: '审核不合格', color: '#ed4014' },
    { value: 6, label: '已驳回', color: '#ed4014' },
];

// 【门店装修状态】
export const storeDecorationStatusDict = [
    { value: 0, label: '签约门店' },
    { value: 4, label: '挂牌店' },
    { value: 1, label: '快捷服务店' },
    { value: 2, label: '车空间店' },
];
// 【门店装修状态-two】
export const storeDecorationStatusTwoDict = [
    { value: 0, label: '挂牌店' },
    { value: 1, label: '快捷服务店' },
    { value: 2, label: '车空间店' },
];

// 门店注册类型
export const storeRegisterTypeDict = [
    { value: 1, label: '注册门店' },
    { value: 0, label: '非注册门店' },
];

// 【巡店-是否已巡】
export const patrolStoreStatusDict = [
    { value: 1, label: '已巡' },
    { value: 0, label: '未巡' },
];

// 【巡店结果标记】
export const confirmStatusDict = [
    { value: 0, label: '未标记', type: 'primary', confirmText: '标记' },
    { value: 1, label: '已确认', type: 'success', confirmText: '已确认' },
    { value: 2, label: '异常', type: 'error', confirmText: '异常' },
];

// 【横幅标记】
export const bannerStatusDict = [
    { value: 0, label: '未标记', type: 'primary', bannerText: '标记' },
    { value: 1, label: '有横幅', type: 'success', bannerText: '有横幅' },
    { value: 2, label: '无横幅', type: 'error', bannerText: '无横幅' },
];

// 【店检统计季度详情店检状态】
export const inspectionStatusDict = [
    { value: 1, label: '未上传' },
    { value: 3, label: '审核中' },
    { value: 4, label: '合格' },
    { value: 5, label: '已驳回' },
    { value: 6, label: '不合格' },
];

// 活动类型
export const specialTypeDict = [
    { value: 0, label: '工厂促销' },
    { value: 1, label: '区域促销' },
];

// 发货状态
export const sendGoodsStatusDict = [
    { value: 0, label: '待发货', shortLabel: '待发货' },
    { value: 1, label: '已部分发货', shortLabel: '部分发货' },
    { value: 2, label: '已全部发货', shortLabel: '全部发货' },
];

// 售后状态
export const afterSaleStatusDict = [
    { value: 1, label: '无售后', shortLabel: '无退款' },
    { value: 2, label: '已部分退款', shortLabel: '部分退款' },
    { value: 3, label: '已全额退款', shortLabel: '全额退款' },
    { value: 4, label: '已部分取消', shortLabel: '部分取消' },
    { value: 5, label: '已全部取消', shortLabel: '全部取消' },
];

// 订单状态
export const saleOrderStatusDict = [
    { value: 1, label: '待付款', color: '#f59a23' },
    { value: 2, label: '已付款(待入库)', color: '#18ba27' },
    { value: 3, label: '已完成', color: '#1890ff' },
    { value: 4, label: '已关闭', color: 'inherit' },
    { value: 5, label: '已下单', color: '#18ba27' },
    { value: 6, label: '已取消', color: 'inherit' },
    { value: 7, label: '已下单(待入库)', color: '#18ba27' },
];

// 单位
export const unitDict = [
    { value: 0, label: '', specialLabel: '/' },
    { value: 1, label: '条', specialLabel: '条' },
    { value: 2, label: '套', specialLabel: '套' },
];

// 线下/线下 支付
export const payChannelsDict = [
    { value: 0, label: '线下支付' },
    { value: 1, label: '线上支付' },
];

// 【新零售签约状态】
export const signStatusDict = [
    { value: 0, label: '未签约' },
    { value: 2, label: '签约中' },
    { value: 1, label: '已签约' },
];

// 【采购单状态】
export const purchaseOrderStatusDict = [
    { value: 0, label: '待处理' },
    { value: 1, label: '已同步' },
    { value: 2, label: '已发货' },
    { value: 3, label: '已取消' },
];
